import UserManage from './user_management'
import RoleManage from './role_management'
import PermessionManagement from './permession_management'
import DetectManagement from './detect_subject_management'
import EmployeeManagement from './employee_management'

export default {
  ...UserManage,
  ...RoleManage,
  ...DetectManagement,
  ...PermessionManagement,
  ...EmployeeManagement
}



// WEBPACK FOOTER //
// ./src/pages/index.js